export default __webpack_public_path__ + "static/media/cunningstrike6.71c71b6d.png";